"use strict";
/** createElement */
(() => {
    const pattern = new RegExp(/^[a-zA-Z0-9_-]+$/);
    const func = Document.prototype.createElement;
    Document.prototype.createElement = function createElement(html) {
        if (html.startsWith('<') === false && pattern.test(html)) {
            return func.apply(this, [html]);
        }
        // trim any spaces
        html = html.trim();
        // make sure we have the correct parent element
        let container;
        if (html.startsWith('<tr')) {
            container = document.createElement('tbody');
        }
        else if (html.startsWith('<td') || html.startsWith('<th')) {
            container = document.createElement('tr');
        }
        else {
            container = document.createElement('div');
        }
        container.innerHTML = html;
        if (container.children.length !== 1) {
            throw new Error('document.createElement can only accept html with a single parent element');
        }
        return container.children.item(0);
    };
})();
//# sourceMappingURL=CreateElement.js.map